var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
import { Vue, Component, Prop, Watch } from "vue-facing-decorator";
import { State } from "vuex-facing-decorator";
import { CompaniesClient, SitesClient, CompanyPermissionsClient, GetUserCompanyAccessViewPaginatedQuery, PaginatedEnumerableOfUserCompanyAccessQuery, UserCompanyAccessQuery, GetSiteListQuery, DeleteUserCompanyAccessCommand, UserCompanyAccessModel, CreateUserCompanyAccessCommand, UpdateUserCompanyAccessCommand, RoleTypeEnum } from "@/app/api/battery-portal-api";
import { LoginState } from "@/app/store/modules/login.state";
import { Notifier } from "@/common/utils/notifier";
import { HttpHelper } from "@/app/utils/http-helper";
import { ArrayHelper } from "@/app/utils/array-helper";
import UserSystemAccessVue from "@/app/vues/admin/user-system-access.vue";
import moment from 'moment';
const companyClient = new CompaniesClient(window.apiUrl);
const siteClient = new SitesClient(window.apiUrl);
const accessClient = new CompanyPermissionsClient(window.apiUrl);
let UserCompanyAccessVue = class UserCompanyAccessVue extends Vue {
    constructor() {
        super(...arguments);
        // simpletons
        this.working = false;
        this.searchAttempted = false;
        this.companiesLoaded = false;
        this.addingPermission = false;
        this.displaySystemPermissions = false;
        this.editingPermission = null;
        this.companyId = null;
        this.siteId = null;
        // models
        this.query = new GetUserCompanyAccessViewPaginatedQuery({
            userId: this.userId,
            pageNo: 1,
            pageSize: 100,
            includeDeleted: false
        });
        this.data = new PaginatedEnumerableOfUserCompanyAccessQuery();
        this.systemAccessFilter = new UserCompanyAccessQuery();
        // arrays
        this.companies = [];
        this.sites = [];
        this.skipCompanyWatcher = false;
    }
    created() {
        this.search();
        this.getCompanies();
    }
    ;
    // get
    getCompanies() {
        companyClient
            .getListGET()
            .then(response => {
            if (!response)
                return;
            this.companies = response.map(company => {
                return {
                    value: company.companyId,
                    text: company.companyName
                };
            });
            this.companyId = this.companies[0].value;
            this.companiesLoaded = true;
        })
            .catch(ex => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        })
            .finally(() => {
            // prepare a new permission for company
            let companyId = parseInt(this.$route.params.companyId) || 0;
            if (!companyId)
                return;
            let idx = ArrayHelper.findFirstIndex(this.companies, (item) => {
                return companyId == item.value;
            });
            if (idx < 0)
                return;
            this.companyId = companyId;
            this.toggleAccessPanel();
        });
        siteClient
            .getListPOST(new GetSiteListQuery({
            includeDeleted: false,
            keywords: null,
            companyId: null
        }))
            .then(response => {
            this.sites = response;
        })
            .catch(ex => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        });
    }
    ;
    search() {
        if (this.working)
            return;
        if (!this.query)
            return;
        this.working = true;
        accessClient
            .search(this.query)
            .then(response => {
            this.data = new PaginatedEnumerableOfUserCompanyAccessQuery();
            if (!response)
                return;
            this.data = response;
            this.query.pageNo = this.data.displayedPage;
            this.query.pageSize = this.data.pageSize;
        })
            .catch((ex) => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        })
            .finally(() => {
            this.working = false;
            this.searchAttempted = true;
            this.displaySystemPermissions = false;
        });
    }
    ;
    view(permission) {
        this.systemAccessFilter = permission;
        this.displaySystemPermissions = !this.displaySystemPermissions;
    }
    ;
    selectForEdit(permission) {
        // If clicking the same row, unselect it
        if (this.editingPermission === permission) {
            this.editingPermission = null;
            return;
        }
        // Close add panel if open
        this.addingPermission = false;
        this.skipCompanyWatcher = true;
        // Set the selected permission for editing
        this.editingPermission = permission;
        this.companyId = permission.companyId;
        this.siteId = permission.siteId || null;
        this.$nextTick(() => {
            this.skipCompanyWatcher = false;
        });
    }
    ;
    onCompanyChange(newCompanyId, oldCompanyId) {
        if (this.skipCompanyWatcher)
            return;
        if (newCompanyId !== oldCompanyId) {
            this.siteId = null;
        }
    }
    cancelEdit() {
        this.editingPermission = null;
        this.companyId = this.companies.length > 0 ? this.companies[0].value : null;
        this.siteId = null;
    }
    ;
    updatePermission() {
        if (this.working)
            return;
        if (!this.editingPermission)
            return;
        if (!this.companyId)
            return;
        // Check if anything actually changed
        if (this.editingPermission.companyId === this.companyId &&
            (this.editingPermission.siteId || null) === this.siteId) {
            Notifier.onWarning("No changes were made.");
            this.cancelEdit();
            return;
        }
        this.working = true;
        accessClient
            .update(this.userId, new UpdateUserCompanyAccessCommand({
            requestModel: new UserCompanyAccessModel({
                companyId: this.companyId,
                siteId: this.siteId,
                userId: this.editingPermission.userId,
                whenGrantedAccessToAllSystems: this.editingPermission.whenGrantedAccessToAllSystems
            }),
            updateCompanyAndSiteIds: true,
            previousCompanyId: this.editingPermission.companyId,
            previousSiteId: this.editingPermission.siteId
        }))
            .then(() => {
            Notifier.onOk();
            this.cancelEdit();
            this.working = false;
            this.search();
        })
            .catch((ex) => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        })
            .finally(() => {
            this.working = false;
        });
    }
    ;
    // set
    add() {
        if (this.working)
            return;
        if (!this.companyId)
            return;
        accessClient
            .add(this.userId, new CreateUserCompanyAccessCommand({ requestModel: new UserCompanyAccessModel({ companyId: this.companyId, siteId: this.siteId, userId: this.userId, whenCreated: new Date(), whenGrantedAccessToAllSystems: new Date() }) }))
            .then(() => {
            Notifier.onOk();
            this.toggleAccessPanel();
            this.search();
        })
            .catch((ex) => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        })
            .finally(() => {
            this.working = false;
        });
    }
    ;
    toggleAccessToAllSystems(permission) {
        if (this.working)
            return;
        console.log('permission.whenGrantedAccessToAllSystems', permission.whenGrantedAccessToAllSystems);
        if (this.roleId == RoleTypeEnum.ClientAdministrator && permission.whenGrantedAccessToAllSystems) {
            Notifier.onWarning("Client Administrator role has access to All Systems!");
            return;
        }
        let tokenGrant = permission.whenGrantedAccessToAllSystems ? undefined : new Date();
        accessClient
            .update(this.userId, new UpdateUserCompanyAccessCommand({
            requestModel: new UserCompanyAccessModel({
                companyId: permission.companyId,
                siteId: permission.siteId,
                userId: this.userId,
                whenCreated: new Date(),
                whenGrantedAccessToAllSystems: tokenGrant
            }),
            updateCompanyAndSiteIds: false,
            previousCompanyId: null,
            previousSiteId: null
        }))
            .then(() => {
            Notifier.onOk();
            this.search();
        })
            .catch((ex) => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        })
            .finally(() => {
            this.working = false;
        });
    }
    ;
    purge(permission) {
        if (this.working)
            return;
        this.$confirmModal.show("Are you sure that you want to permanently delete this company permission? This action cannot be undone.", { title: "Please confirm" })
            .then((value) => {
            if (!value)
                return;
            accessClient
                .delete(this.userId, new DeleteUserCompanyAccessCommand({
                requestModel: new UserCompanyAccessModel({
                    companyId: permission.companyId,
                    siteId: permission.siteId,
                    userId: permission.userId,
                    whenCreated: permission.whenCreated
                }),
                forceDelete: false
            }))
                .then(() => {
                Notifier.onOk();
                this.search();
            })
                .catch((ex) => {
                HttpHelper.handleResponse(ex, () => {
                    Notifier.onServerError(ex);
                });
            })
                .finally(() => {
                this.working = false;
            });
        });
    }
    ;
    toggleAccessPanel() {
        this.addingPermission = !this.addingPermission;
        // Cancel editing mode when opening add panel
        if (this.addingPermission) {
            this.editingPermission = null;
        }
    }
    ;
    reload() {
        this.systemAccessFilter.init(new UserCompanyAccessQuery());
        this.editingPermission = null;
        this.search();
    }
    ;
    getFormattedDate(date) {
        return moment(date).format("DD MMM YYYY");
    }
    get filteredSites() {
        return [
            { value: null, text: 'All sites' },
            ...this.sites
                .filter(site => site.companyId == this.companyId)
                .map(site => ({
                value: site.siteId,
                text: site.siteName
            }))
        ];
    }
    ;
    get noData() {
        return this.searchAttempted && (!this.data || !this.data.records || !this.data.records.length);
    }
    ;
    get isPowerShield() {
        return this.loginState.isPowerShield;
    }
    ;
    /**
     * Determines if user can deleted a company access record. True for PowerShield users or if user has more that one company access permission token.
     * Used to prevent client administrators from creating company-less user accounts.
     * */
    get canDeleteCompanyAccess() {
        return this.isPowerShield;
    }
    ;
};
__decorate([
    State("loginModule"),
    __metadata("design:type", typeof (_a = typeof LoginState !== "undefined" && LoginState) === "function" ? _a : Object)
], UserCompanyAccessVue.prototype, "loginState", void 0);
__decorate([
    Prop(),
    __metadata("design:type", Number)
], UserCompanyAccessVue.prototype, "userId", void 0);
__decorate([
    Prop(),
    __metadata("design:type", Number)
], UserCompanyAccessVue.prototype, "roleId", void 0);
__decorate([
    Watch("query.pageNo"),
    Watch("query.includeDeleted"),
    Watch("query.userId"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], UserCompanyAccessVue.prototype, "search", null);
__decorate([
    Watch("companyId"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], UserCompanyAccessVue.prototype, "onCompanyChange", null);
UserCompanyAccessVue = __decorate([
    Component({
        name: "UserCompanyAccessVue",
        components: {
            UserSystemAccessVue
        }
    })
], UserCompanyAccessVue);
export default UserCompanyAccessVue;
